import React, { RefObject } from 'react';

interface GameCanvasProps {
  width: string;
  height: string;
  score: number;
  onJump: () => void;
  canvasRef: React.RefObject<HTMLCanvasElement>;
  debugData?: {
    level: number;
    debrisHit: number;
    debrisAvoided: number;
    reactionTime: number;
    reactionCount: number;
    spawnTimesCount: number;
  };
}

const GameCanvas: React.FC<GameCanvasProps> = ({
  width,
  height,
  score,
  onJump,
  canvasRef,
  debugData
}) => {
  return (
    <div className="relative">
      <canvas
        ref={canvasRef}
        width={960}
        height={540}
        onClick={onJump}
        className="cursor-pointer border border-gray-600"
        style={{ width, height }}
      />
      
      {/* Game overlay */}
      <div className="absolute top-4 right-4 bg-black bg-opacity-50 text-white p-4 rounded-lg">
        <div className="text-center space-y-2">
          <div>
            <div className="text-2xl font-bold text-green-400">{score}</div>
            <div className="text-sm">Score</div>
          </div>
        </div>
      </div>
      
      {/* Debug display */}
      {debugData && (
        <div className="absolute top-4 left-4 bg-black bg-opacity-70 text-white p-3 rounded-lg text-xs font-mono">
          <div>Level: {debugData.level}</div>
          <div>Debris Hit: {debugData.debrisHit}</div>
          <div>Debris Avoided: {debugData.debrisAvoided}</div>
          <div>Reaction Time: {debugData.reactionTime.toFixed(0)}ms</div>
          <div>Reaction Count: {debugData.reactionCount}</div>
          <div>Spawn Times: {debugData.spawnTimesCount}</div>
        </div>
      )}
    </div>
  );
};

export default GameCanvas;
